import { Action } from 'redux';
import { Workspace } from '../../clients/aasServerClient.generated';

export enum ActionTypeNames {
    FetchTableWorkspaces = 'Workspaces/FetchTableWorkspaces',
    FetchTableWorkspacesNF = 'Workspaces/FetchTableWorkspacesNF',
    StoreTableWorkspaces = 'Workspaces/StoreTableWorkspaces',

    FetchAllWorkspaces = 'Workspaces/FetchAllWorkspaces',
    StoreAllWorkspaces = 'Workspaces/StoreAllWorkspaces',

    ClearSingleWorkspace = 'Workspaces/ClearSingleWorkspace',
    FetchSingleWorkspace = 'Workspaces/FetchSingleWorkspace',
    NewSingleWorkspace = 'Workspaces/NewSingleWorkspace',
    CopySingleWorkspace = 'Workspaces/CopySingleWorkspace',
    StoreSingleWorkspace = 'Workspaces/StoreSingleWorkspace',
    CreateSingleWorkspace = 'Workspaces/CreateSingleWorkspace',
    SaveSingleWorkspace = 'Workspaces/SaveSingleWorkspace',
    SavedSingleWorkspace = 'Workspaces/SavedSingleWorkspace',

    DeleteWorkspaces = 'Workspaces/DeleteWorkspaces',
    AssignGroupsWorkspaces = 'Workspaces/AssignGroupsWorkspaces',
    AssignApplicationsWorkspace = 'Workspaces/AssignApplicationsWorkspace',
}

export type WorkspacesAction<T extends ActionTypeNames> = Action<T> & {
    workspaceIds: string[];
};

export type FetchTableWorkspacesNFAction = Action<ActionTypeNames.FetchTableWorkspacesNF>;

export type FetchTableWorkspacesAction = Action<ActionTypeNames.FetchTableWorkspaces>;
export type StoreTableWorkspacesAction = Action<ActionTypeNames.StoreTableWorkspaces> & {
    workspaces: Workspace[]
};

export type FetchAllWorkspacesAction = Action<ActionTypeNames.FetchAllWorkspaces>;
export type StoreAllWorkspacesAction = Action<ActionTypeNames.StoreAllWorkspaces> & {
    workspaces: Workspace[]
};

export type FetchSingleWorkspaceAction = Action<ActionTypeNames.FetchSingleWorkspace> & {
    id: string;
};
export type NewSingleWorkspaceAction = Action<ActionTypeNames.NewSingleWorkspace>;
export type CopySingleWorkspaceAction = Action<ActionTypeNames.CopySingleWorkspace> & {
    id: string;
};
export type StoreSingleWorkspaceAction = Action<ActionTypeNames.StoreSingleWorkspace> & {
    workspace: Partial<Workspace>;
};
export type SaveSingleWorkspaceAction = Action<ActionTypeNames.SaveSingleWorkspace> & {
    workspace: Partial<Workspace>;
    groups?: Array<{ id: string, value: boolean }>;
    parentId?: string;
};

export type CreateSingleWorkspaceAction = Action<ActionTypeNames.CreateSingleWorkspace> & {
    workspace: Partial<Workspace>;
    groups?: Array<{ id: string, value: boolean }>;
    parentId?: string;
};

export type ClearSingleWorkspaceAction = Action<ActionTypeNames.ClearSingleWorkspace>;
export type SavedSingleWorkspaceAction = Action<ActionTypeNames.SavedSingleWorkspace>;

export type DeleteWorkspacesAction = WorkspacesAction<ActionTypeNames.DeleteWorkspaces>;
export type AssignGroupsWorkspacesAction = WorkspacesAction<ActionTypeNames.AssignGroupsWorkspaces> & {
    groupIds: string[];
};
export type AssignApplicationsWorkspaceAction = Action<ActionTypeNames.AssignApplicationsWorkspace> & {
    applicationIds: string[];
    workspaceId: string;
};
